// add loader and disabled class to gform submits to prevent multiple submits
$('.gform_wrapper form').on('submit', function (e) {
    let $submit = $(this).closest('.gform_wrapper').find('.gform_footer *[type="submit"]');

    if (!$submit.hasClass('btn-disabled')) {
        $submit.addClass('btn-disabled').prepend('<i class="icon-left fas fa-spinner fa-spin"></i>').blur();
    } else {
        e.preventDefault();
    }
});


// hide .gform_heading if .gform_description is only child and is empty
$('.gform_wrapper .gform_heading .gform_description').each(function () {
    let $heading = $(this).closest('.gform_heading');
    let $description = $(this);

    // if description is empty, hide it
    if ($description.html() === '') {
        $description.hide();

        // if description is empty, and only child, hide heading
        if ($description.siblings().length < 1) {
            $heading.hide();
        }
    }
});


// hide gform footer if only contains hidden inputs
$('.gform_footer').each(function () {
    if ($('input', this).length === $('input[type="hidden"]', this).length) {
        $(this).hide();
    }
});